export const consoleLogger = {
    debug: (message, fields) => console.debug(message, fields ?? {}),
    info: (message, fields) => console.info(message, fields ?? {}),
    warn: (message, fields) => console.warn(message, fields ?? {}),
};
//# sourceMappingURL=logger.js.map